/**
 * @param {Intl.NumberFormat?} formatter
 * @param {number?} value
 */
export function formatNumber (formatter, value) {
	return formatter instanceof Intl.NumberFormat && !isNaN(value)
		? formatter.format(value)
		: value;
}

export function formatTime (formatter, value, inputFormat = 'ns') {
	return inputFormat === 'ns'
		? formatNumber(formatter, value / 1000000)
		: formatNumber(formatter, value); // 1000000 nanoseonds in a miliseconds
}

export function hslToHex (h, s, l) {
  h /= 360;
  s /= 100;
  l /= 100;
  let r, g, b;
  if (s === 0) {
    r = g = b = l; // achromatic
  } else {
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    r = hueToRgb(p, q, h + 1 / 3);
    g = hueToRgb(p, q, h);
    b = hueToRgb(p, q, h - 1 / 3);
  }
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}

function toHex (x) {
	return Math.round(x * 255).toString(16).padStart(2, '0');
}

function hueToRgb (p, q, t) {
	if (t < 0) t += 1;
	if (t > 1) t -= 1;
	if (t < 1 / 6) return p + (q - p) * 6 * t;
	if (t < 1 / 2) return q;
	if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
	return p;
}



// WEBPACK FOOTER //
// ./util.js